import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

const useStyles = () => ({
  filtersDesktopBackground: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#ffffff',
      zIndex: '120',
      height: '83px',
      borderBottom: `1px solid ${COLORS.gray.light2}`,
    },
  },
  filtersDetailsBackground: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      width: '100%',
      backgroundColor: 'transparent',
      height: '84px',
      position: 'fixed',
      zIndex: '-1',
    },
  },
  gridBackground: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      width: '100%',
      position: 'fixed',
      zIndex: '-1',
      backgroundColor: '#FAFAFA',
    },
  },
  gridBackgroundWishlist: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      width: '100%',
      position: 'fixed',
      zIndex: '-1',
      height: '100vh',
      backgroundColor: '#F5F8F9',
    },
  },
});

export default useStyles;
